import keys from '@debbie/common/dist/cache/keys.js';
import { useMemo } from 'react';
import * as api from '../api/procedures.js';
import { h } from '../index.js';
import { mapLoadable } from '../Loadable/utils.js';
import q from '../query.js';
export const proceduresEntity = 'procedures';
const proceduresKey = 'procedures';
export const useProcedures = (options) => q.query(proceduresKey, api.get, keys.read.collection(proceduresEntity), {
    enabled: options?.enabled,
});
export const useCaseProcedures = (caseCreditorId, caseCollectorId) => {
    const proceduresLoadable = useProcedures();
    const filtered = useMemo(() => {
        if (!h.hasData(proceduresLoadable)) {
            return null;
        }
        return proceduresLoadable.data.filter((procedure) => {
            const isCreditorSame = !procedure.creditorId || procedure.creditorId === caseCreditorId;
            const isCollectorSame = !procedure.collectorId || procedure.collectorId === caseCollectorId;
            return isCreditorSame && isCollectorSame && procedure.showOnCase;
        });
    }, [proceduresLoadable, caseCreditorId, caseCollectorId]);
    return mapLoadable(proceduresLoadable, filtered);
};
//# sourceMappingURL=index.js.map